import { authDispatcher } from '../auth';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Box, Typography, makeStyles } from '@material-ui/core';
import CheckCircleOutlined from '@material-ui/icons/CheckCircleOutlined';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
  title: {
    fontSize: 20,
    letterSpacing: 0,
    fontWeight: 600,
    marginBottom: 8,
  },
  successIcon: {
    fontSize: 64,
    color: '#66bb6a',
    marginBottom: 16,
  },
  errorIcon: {
    fontSize: 64,
    color: '#eb6c75',
    marginBottom: 16,
  },
});

const AcknowledgeNudgeScreen = ({ ...props }) => {
  const classes = useStyles();
  const [confirmSuccessfull, setConfirmSuccessfull] = useState();

  const queryParams = new URLSearchParams(props.location.search);
  const token = queryParams.get('token');
  const angelId = queryParams.get('angelId');
  const userId = queryParams.get('userId');
  const referenceId = queryParams.get('referenceId');
  const title = queryParams.get('header');
  const body = queryParams.get('body');

  useEffect(() => {
    authDispatcher.acknowledgeNudgeAngelsEmail(
      {
        token,
        angelId,
        userId,
        referenceId,
      },
      (isSucces) => {
        isSucces
          ? setConfirmSuccessfull('success')
          : setConfirmSuccessfull('failure');
      }
    );
  }, [token, angelId, userId, referenceId]);

  return (
    <div>
      <Box p={3} borderRadius={10} textAlign="center" bgcolor="white">
        <CheckCircleOutlined className={classes.successIcon} />

        <Typography className={classes.title}>{title}</Typography>

        <Typography variant="body2">{body}</Typography>
      </Box>
    </div>
  );
};

export default AcknowledgeNudgeScreen;
